'use client';

import {
  Box,
  Container,
  SimpleGrid,
  Stack,
  Text,
  Flex,
  Icon,
  Image,
} from '@chakra-ui/react';

import {
  FaDiscord,
  FaYoutube,
  FaTelegramPlane,
  FaTwitter,
} from 'react-icons/fa';
import { AiFillInstagram } from 'react-icons/ai';
import logo from '../../image/logo.png';
import img from '../../image/ugs.webp';

const ListHeader = ({ children }) => {
  return (
    <Text fontWeight={'500'} fontSize={'lg'} mb={2} color={'white'}>
      {children}
    </Text>
  );
};

export default function Footer() {
  return (
    <Box>
      <Container as={Stack} maxW={'6xl'} py={10}>
        <SimpleGrid columns={{ base: 1, sm: 2, md: 4 }} spacing={8}>
          <Stack align={'flex-start'}>
            <ListHeader>Company</ListHeader>
            <Box
              as="a"
              href={'/'}
              color={'whiteAlpha.600'}
              transition={'0.2s ease'}
              _hover={{ color: '#fffa2b', transition: '0.2s ease' }}
            >
              Home
            </Box>
            <Box
              as="a"
              href={'/roadmap'}
              color={'whiteAlpha.600'}
              transition={'0.2s ease'}
              _hover={{ color: '#fffa2b', transition: '0.2s ease' }}
            >
              Roadmap
            </Box>
            <Box
              as="a"
              href={'/contact'}
              color={'whiteAlpha.600'}
              transition={'0.2s ease'}
              _hover={{ color: '#fffa2b', transition: '0.2s ease' }}
            >
              Contact
            </Box>
          </Stack>
          <Stack align={'flex-start'}>
            <ListHeader>Whitepaper</ListHeader>
            <Box
              as="a"
              href={'https://unipolycoin.com/WhitePaperTR.pdf'}
              color={'whiteAlpha.600'}
              transition={'0.2s ease'}
              _hover={{ color: '#fffa2b', transition: '0.2s ease' }}
            >
              Turkish
            </Box>
            <Box
              as="a"
              href={'https://unipolycoin.com/WhitePaperEn.pdf'}
              color={'whiteAlpha.600'}
              transition={'0.2s ease'}
              _hover={{ color: '#fffa2b', transition: '0.2s ease' }}
            >
              English
            </Box>
          </Stack>
          <Stack align={'flex-start'}>
            <ListHeader>Unipoly Game Studio</ListHeader>
            <Box as="a" href={'https://unipolygames.com/'} mt={2}>
              <Image src={img} h={45} w={170} loading="lazy" />
            </Box>
          </Stack>

          <Stack align={'flex-start'} p={'0px 5px'}>
            <ListHeader>Follow Us</ListHeader>
            <Stack direction={'row'} justify={'space-evenl'}>
              <Box
                as="a"
                href={'https://www.instagram.com/unipolycoin/'}
                color={'whiteAlpha.600'}
              >
                <Icon
                  as={AiFillInstagram}
                  w={7}
                  h={7}
                  transition={'0.2s ease'}
                  _hover={{ color: '#fffa2b', transition: '0.2s ease' }}
                />
              </Box>
              <Box
                as="a"
                href={'https://twitter.com/unipolycoin'}
                color={'whiteAlpha.600'}
              >
                <Icon
                  as={FaTwitter}
                  w={7}
                  h={7}
                  transition={'0.2s ease'}
                  _hover={{ color: '#fffa2b', transition: '0.2s ease' }}
                />
              </Box>
              <Box
                as="a"
                href={'https://www.youtube.com/@unipolycoin'}
                color={'whiteAlpha.600'}
              >
                <Icon
                  as={FaYoutube}
                  w={7}
                  h={7}
                  transition={'0.2s ease'}
                  _hover={{ color: '#fffa2b', transition: '0.2s ease' }}
                />
              </Box>
              <Box
                as="a"
                href={'https://t.me/unipolycoin'}
                color={'whiteAlpha.600'}
              >
                <Icon
                  as={FaTelegramPlane}
                  w={7}
                  h={7}
                  transition={'0.2s ease'}
                  _hover={{ color: '#fffa2b', transition: '0.2s ease' }}
                />
              </Box>
              <Box
                as="a"
                href={'https://discord.com/invite/RWTgABaruQ'}
                color={'whiteAlpha.600'}
              >
                <Icon
                  as={FaDiscord}
                  w={7}
                  h={7}
                  transition={'0.2s ease'}
                  _hover={{ color: '#fffa2b', transition: '0.2s ease' }}
                />
              </Box>
            </Stack>
          </Stack>
        </SimpleGrid>
      </Container>
      <Box py={10}>
        <Flex
          align={'center'}
          _before={{
            content: '""',
            borderBottom: '1px solid',
            borderColor: '#fffa2b ',
            flexGrow: 1,
            mr: 8,
          }}
          _after={{
            content: '""',
            borderBottom: '1px solid',
            borderColor: '#fffa2b ',
            flexGrow: 1,
            ml: 20,
          }}
        >
          <Image src={logo} w={'200px'} ml={'50px'} loading="lazy"></Image>
        </Flex>
        <Text
          pt={6}
          fontSize={'sm'}
          textAlign={'center'}
          fontWeight={'400'}
          color={'gray.500'}
        >
          © All right reserved 2023.
        </Text>
        <Text
          pt={1}
          fontSize={'sm'}
          textAlign={'center'}
          fontWeight={'400'}
          color={'gray.500'}
          _hover={{ color: '#fffa2b' }}
        >
          <a href="https://unipolygames.com/">Unipoly Game Studio </a>
        </Text>
      </Box>
    </Box>
  );
}
